import i18n from '@/i18n';
import { isClientError } from 'cesg-shared';
import type { NotificationMatcher } from './notification-matcher';

export const sharePointProjectNotFoundNotification: NotificationMatcher = (
  error,
) => {
  if (!isClientError(error, 'SHAREPOINT_PROJECT_NOT_FOUND')) return null;

  const { t } = i18n.global;
  return {
    title: t('errorNotifications.SHAREPOINT_PROJECT_NOT_FOUND.title'),
    text: t('errorNotifications.SHAREPOINT_PROJECT_NOT_FOUND.text'),
    type: 'danger',
  };
};
